import React, { useState, useEffect } from 'react';
import { Col, Row, Form } from 'react-bootstrap';
import { casedateFormatter, DBFieldSchema, getConfigurationDataKey } from '../utils';
import { AnyType } from '../interfaces';
import { useSelector } from 'react-redux';
import { tenancyFeatureSelector } from '../redux/selectors';
import { isEmptyObject } from '../utils/helpers';
import './CaseDetailMainSectionSummaryTab.scss';

export type PITabProps = {
  prescriptionIntakes?: AnyType[] | AnyType;
};

export const PrescriptionIntakesection = (props: PITabProps) => {
  const [summaryFields, setSummaryFields]: [DBFieldSchema, AnyType] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const setSummaryFieldsSchema = async () => {
    const summaryFieldsSchema: AnyType = await useSelector<AnyType>(
      tenancyFeatureSelector(getConfigurationDataKey('casedetails.summary'))
    );
    if (summaryFieldsSchema) {
      const { fields } = await summaryFieldsSchema;
      setSummaryFields(fields);
    }
  };
  setSummaryFieldsSchema();

  useEffect(() => {
    if (summaryFields && !isEmptyObject(summaryFields)) {
      setIsLoading(false);
    }
  }, [summaryFields]);

  const formFields = summaryFields;
  return !isLoading ? (
    <>
      <Row>
        <Col className={formFields?.prescription_intake_medication_name?.hideField ? 'd-none' : ''}>
          <Form.Label className='detail__label text-secondary'>
            {formFields?.prescription_intake_medication_name?.label}
          </Form.Label>
        </Col>
        <Col className={formFields?.prescription_intake_id?.hideField ? 'd-none' : ''}>
          <Form.Label className='detail__label text-secondary'>{formFields?.prescription_intake_id?.label}</Form.Label>
        </Col>
        <Col className={formFields?.prescription_intake_dose_type?.hideField ? 'd-none' : ''}>
          <Form.Label className='detail__label text-secondary'>
            {formFields?.prescription_intake_dose_type?.label}
          </Form.Label>
        </Col>

        <Col className={formFields?.prescription_intake_received_date?.hideField ? 'd-none' : ''}>
          <Form.Label className='detail__label text-secondary'>
            {formFields?.prescription_intake_received_date?.label}
          </Form.Label>
        </Col>
        <Col className={formFields?.prescription_intake_ndc?.hideField ? 'd-none' : ''}>
          <Form.Label className='detail__label text-secondary'>{formFields?.prescription_intake_ndc?.label}</Form.Label>
        </Col>
        <Col className={formFields?.prescription_intake_quantity?.hideField ? 'd-none' : ''}>
          <Form.Label className='detail__label text-secondary'>
            {formFields?.prescription_intake_quantity?.label}
          </Form.Label>
        </Col>
      </Row>
      <Row>
        <Col className={formFields?.prescription_intake_medication_name?.hideField ? 'd-none' : ''}>
          <p className='detail__value'>{props.prescriptionIntakes?.drugName ?? '---'}</p>
        </Col>
        <Col className={formFields?.prescription_intake_id?.hideField ? 'd-none' : ''}>
          <p className='detail__value'>{props.prescriptionIntakes?.prescriptionId ?? '---'}</p>
        </Col>
        <Col className={formFields?.prescription_intake_dose_type?.hideField ? 'd-none' : ''}>
          <p className='detail__value'>{props.prescriptionIntakes?.doseType ?? '---'}</p>
        </Col>

        <Col className={formFields?.prescription_intake_received_date?.hideField ? 'd-none' : ''}>
          <p className='detail__value'>
            {casedateFormatter(props.prescriptionIntakes?.prescriptionReceivedDate) ?? '---'}
          </p>
        </Col>
        <Col className={formFields?.prescription_intake_ndc?.hideField ? 'd-none' : ''}>
          <p className='detail__value'>{props.prescriptionIntakes?.ndc ?? '---'}</p>
        </Col>
        <Col className={formFields?.prescription_intake_quantity?.hideField ? 'd-none' : ''}>
          <p className='detail__value'>{props.prescriptionIntakes?.quantity ?? '---'}</p>
        </Col>
      </Row>
    </>
  ) : (
    <> </>
  );
};
